import type { BoxProps} from '@chakra-ui/react'
import { Box, Checkbox, Text } from '@chakra-ui/react'
import type { MouseEventHandler } from 'react'

import { useOfferGrid } from '@/context/OfferGridContext'
import type { IBodyCell, IHeaderCell } from 'BrokerTsLib/src/interfaces/offers/grid/columnSections'
import { OfferCell } from '../OfferCell'
import { OfferCellWrapper } from '../OfferCellWrapper'
import { SectionBody } from '../SectionBody'
import { SectionTitle } from '../SectionTitle'
import type { icons } from '../icons'

export interface IOfferPackageColumnSection {
  sectioId?: number
  title?: string
  icon?: keyof typeof icons | ''
  isOpened?: boolean
  onClick: MouseEventHandler<HTMLDivElement>
  headerCells?: Array<IHeaderCell>
  bodyCells?: Array<IBodyCell[]>
  titleBg?: string
  handleToggleAll?: (show: boolean, riskId: number) => void
  isDisabled?: boolean
}

export const OfferPackageColumnSection = ({
  sectioId,
  title,
  icon,
  isOpened = false,
  onClick,
  headerCells,
  bodyCells,
  titleBg,
  handleToggleAll,
  isDisabled,
  ...rest
}: IOfferPackageColumnSection & BoxProps) => {

  const { risks } = useOfferGrid()

  return (
    <Box id={sectioId} {...rest}>
      <SectionTitle label={title} icon={icon} isOpened={isOpened} onClick={onClick} bg={titleBg} />

      <SectionBody isOpened={isOpened}>
        {headerCells &&
          headerCells.length > 0 &&
          headerCells.map(({ id, title }) => {
            const idInt = parseInt(id)
            const riskItem = risks.find(x => x.riskId == idInt)

            return (
              <OfferCellWrapper key={id} riskId={idInt}>
                <Text sx={{ pl: '24px', fontSize: 'sm', whiteSpace: 'nowrap' }}>{title}</Text>

                {handleToggleAll &&
                  <Checkbox
                    size="sm"
                    ml='auto'
                    disabled={isDisabled || !riskItem?.addable}
                    isChecked={!!riskItem?.selected}
                    onChange={e => handleToggleAll(!riskItem?.selected, idInt)}
                  />
                }
              </OfferCellWrapper>
            )
          })}

        {bodyCells &&
          bodyCells.length > 0 &&
          bodyCells.map((cell, index) => {
            if (Array.isArray(cell) && cell.length > 1) {
              return (
                <Box
                  key={index}
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${cell.length}, 1fr)`,
                    justifyContent: 'end',
                  }}
                >
                  {cell.map((cellItem, i) => (
                    <OfferCell
                      key={i}
                      {...cellItem}
                      singleCell={false}
                    />
                  ))}
                </Box>
              )
            }

            return <OfferCell key={cell[0]?.id ?? index} {...cell[0] ?? {}} />
          })}
      </SectionBody>
    </Box>
  )
}
